<div class="dialog modal-md">
    <div class="dialog-title">
        <h4>Create New Ticket<img src="assets/svg/close-white.svg" alt="close" (click)="close()" ></h4>
    </div>
    <div class="content" [formGroup]="createTicketForm">
        <h2>Need Assistance? We Are Here To Help!</h2>
        <p>Let us know what area you need help with.</p>
        <div class="custom-form mt-1">
            <label>Ticket Type </label>
            <div class="form-group no-mar">
            <div class="autocomplete" #customTip>
                <select class="select arrow-img"  formControlName="ticketType" (change)="changeTicketType($event.target.value)">
                    <option value="">Select Ticket Type</option>
                    <option value="Technical Support">Technical Support</option>
                    <option value="Partner Order">Partner Order</option>
                </select>
                <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && createTicketForm.controls.ticketType.invalid">Ticket Type Required</span>
            </div>

          </div>
        </div>
        <div class="custom-form mt-1" *ngIf="!techSupport" >
            <label>Quote Number</label>
            <div class="form-group no-mar">
                <div class="autocomplete" #customTip>
                    <select class="select arrow-img" formControlName="quoteNumber" [(ngModel)]="selectedQuoteNo" (change)="changeQuoteNumber($event.target.value)">
                        <option value="">Select Quote Number</option>
                        <option value="{{item.quotationId}}" *ngFor="let item of quoteList" >{{item.code}}</option>
                    </select>
                    <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && createTicketForm.controls.quoteNumber.invalid">Quote Number Required</span>
                </div>
            </div>
        </div>
        <div class="custom-form">
            <label>MESSAGE</label>
            <textarea rows="4" cols="68" formControlName="message" placeholder="Enter message for Ticket"></textarea>
            <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && createTicketForm.controls.message.invalid">Message Required</span>
        </div>
        <br>
        <div class="custom-form mt-1">
        <span class="cls-file">
            <a class="upload-btn-wrapper" id="btn">
                <input type="file" formControlName="uploadFile" (change)="onFileSelected($event)" />
                <i class="fa fa-upload"></i>
                <span>&nbsp; Add a File</span>
            </a>  
            <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && createTicketForm.controls.uploadFile.invalid">File Required</span>        
        </span>
        <span>{{uploadedFileName}}</span>
       </div>
        <button class="bor-orange" (click)="createTicket()">Create Ticket</button>
    </div>
</div>

<div *ngIf="showLoader" class="loader">
    <img src="assets/svg/preloader.svg" alt="">
</div>
